export default "__VITE_ASSET__BhJ9ZFk___"